import { render, staticRenderFns } from "./WorkspaceHypothesesBubble.vue?vue&type=template&id=6533563e&scoped=true"
import script from "./WorkspaceHypothesesBubble.vue?vue&type=script&lang=js"
export * from "./WorkspaceHypothesesBubble.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceHypothesesBubble.vue?vue&type=style&index=0&id=6533563e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6533563e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6533563e')) {
      api.createRecord('6533563e', component.options)
    } else {
      api.reload('6533563e', component.options)
    }
    module.hot.accept("./WorkspaceHypothesesBubble.vue?vue&type=template&id=6533563e&scoped=true", function () {
      api.rerender('6533563e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceHypothesesBubble.vue"
export default component.exports